import { Icon } from "@iconify/react";
import { Card, CardBody } from "@nextui-org/card";

import { subtitle } from "@/components/primitives";
import { works } from "@/public/assets/data/landing-page";

export const GuideSection = () => {
  const itemStyle = "lg:w-1/4 sm:w-full mx-5 my-6";

  return (
    <div className="flex ct-hero ct-section w-full justify-center md:mx-auto">
      <div className="flex flex-col justify-center items-center lg:w-full w-5/6">
        <div className="container">
          <div className="columns-1 flex justify-center pt-[80px] lg:pb-[80px] sm:pb-[30px]">
            <div className="flex flex-col items-center justify-center">
              <h3
                className="my-2 text-start text-lg lg:text-xl text-default-600 font-semibold ct-text-primary"
                data-aos="fade-up"
              >
                How it works
              </h3>
              <div className="inline-block max-w-xl text-center justify-center">
                <h2
                  className={subtitle({ fullWidth: false })}
                  data-aos="fade-up"
                  data-aos-delay="300">
                  Converting USDT and other Cryptocurrencies to Yuan, Indian
                  Rupee and others: A Simple, Swift, and Secure Process
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="flex flex-row flex-wrap justify-center items-center pb-[80px]">
            {works.map(({ id, title, des, icon }) => (
              <div key={id} className={itemStyle} data-aos="fade-right">
                <Card className="py-4 px-4 ct-border">
                  <CardBody className="text-center rounded-md ct-faint-bg justify-center items-center">
                    <div className="ct-icon-box ct-border ct-bg-white mb-5 mt-4 shadow-md flex flex-col rounded-md p-3 lg:p-3 justify-center items-center">
                      <Icon
                        className="ct-text-primary"
                        height="56"
                        icon={icon}
                      />
                    </div>
                    <h4 className="text-lg lg:text-xl text-default-600 font-bold">
                      {title}
                    </h4>
                    <p className="py-5 px-3">{des}</p>
                  </CardBody>
                </Card>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
